<a
    class="group block"
    [hyundaiRouterLink]="data().link"
    [fragment]="data().linkFragment"
    [queryParams]="data().linkQueryParams"
    [trackingElLabel]="data().headline"
    [trackingElTarget]="data().link"
    tracking
    trackingElType="image"
>
    <div class="bg-grey-100 mb-8 flex aspect-square items-center justify-center">
        @if (data().image; as imageData) {
            <ui-m000-c010-image
                class="block overflow-hidden"
                [image]="{
                    image: imageData.url,
                    desktop: { width: 262, height: 262 },
                    tablet: { width: 232, height: 232 },
                    mobile: { width: 351, height: 351 },
                }"
                [priority]="isFirstView()"
                [alt]="imageData.alt ?? ''"
                classList="image-hover w-full aspect-square"
                cover
            />
        } @else {
            <i class="icon-logo size-1/3 text-white md:size-64 md:text-[64px]"></i>
        }
    </div>
    <div class="flex justify-between gap-8">
        @let headline = data().headline | footnotes;
        <p class="text-16 leading-27 text-black" [innerHTML]="headline()"></p>

        @if (!data().price) {
            <i class="icon-chevron-right group-hover:animate-bouncing-left text-16 text-black"></i>
        }
    </div>
    @if (data().price) {
        <div class="mt-4 flex w-full items-center justify-between gap-8">
            @let priceText = `${data().priceLabel} ${data().price}` | footnotes;
            <p class="font-headline text-16 leading-27 font-medium text-black" [innerHTML]="priceText()"></p>
            <i class="icon-chevron-right group-hover:animate-bouncing-left text-16 text-black"></i>
        </div>
    }
</a>
